import React, { useState, useEffect, useContext } from "react";
import AddProject from "../components/AddProject";
import UpdateProduct from "../components/UpdateProduct";
import AuthContext from "../AuthContext";
import Projects from '../components/Tables/Project'
import { useTheme } from '../ThemeContext'; // Adjust the path as necessary
function Inventory() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [products, setAllProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState();
  const [updatePage, setUpdatePage] = useState(true);
  const [stores, setAllStores] = useState([]);
  const { theme } = useTheme(); // Get the theme from context
  const authContext = useContext(AuthContext);
  const user = JSON.parse(localStorage.getItem('user'));
  const role = user?.authority
  // Modal for Product ADD
  const addModalSetting = () => {
    setShowProductModal(!showProductModal);
  };

  // Modal for Product UPDATE
  const updateProductModalSetting = (selectedProductData) => {
    console.log("Clicked: edit");
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };


  // Handle Page Update
  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };


  return (
    <div className="col-span-12 lg:col-span-10  flex justify-center">
      <div className="flex flex-col gap-5 w-full"> {/* Flex column with full width */}
        {showProductModal && (
          <AddProject
            addModalSetting={addModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}
        {showUpdateModal && (
          <UpdateProduct
            updateProductData={updateProduct}
            updateModalSetting={updateProductModalSetting}
          />
        )}

        {/* Table  */}
        <div className={`overflow-x-auto rounded-sm border w-full ${theme === 'dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'}`}> {/* Full width table */}
          <div className="flex justify-between pt-5 pb-3 px-3">
            <div className="flex gap-4 justify-center items-center">
              <span className={`font-bold text-xl ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Projects</span>
            </div>
            {role === 'superadmin' && (
              <div className="flex gap-4">
                <button
                  className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={addModalSetting}
                >
                  {/* <Link to="/inventory/add-product">Add Product</Link> */}
                  Add Project
                </button>
              </div>
            )}
          </div>
          <Projects update={updatePage} />
        </div>
      </div>
    </div>
  );
}

export default Inventory;
